<template>
  <div class="emd-container">
    <div class="eu emd-container__header eu-py_4_md eu-px_5_md">
      <div class="eu-basis_6 eu-basis_4_md">
        <div class="eu-flex eu-flex-item eu-basis_12 eu-basis_12_md">
          <a class="emd-input-icon__link collapse-icon " @click="showContent = !showContent" v-if="collapse">
            <i class="uil uil-angle-down" v-if="showContent" />
            <i class="uil uil-angle-right" v-else />
          </a>
          <h2 class="emd-text _size_section _color_default padding-title">{{ title }}</h2>
        </div>
        <div class="eu-flex-item eu-basis_12 eu-basis_12_md">
          <slot name="subtitle"/>
        </div>
      </div>
      <div class="eu-flex eu-justify_end _align-end eu-basis_6 eu-basis_2_md">
        <div class="eu-flex-item eu-basis_6 eu-basis_3_md eu-flex eu-justify_end padding-icon">
          <slot name="icon"/>
        </div>
      </div>
    </div>
    <div>
      <hr class="emd-divider" />
      <div class="emd-container__content eu-pa_5_md" v-if="!summary && (!collapse || showContent)">
        <slot name="content"  v-if="!collapse || showContent"/>
      </div>
      <slot name="summary" v-if="!collapse || showContent"/>
      <slot name="footer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmdContainer',
  data () {
    return {
      showContent: true
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    collapse: {
      type: Boolean,
      required: false
    },
    summary: {
      type: Boolean,
      required: false
    }
  }
}
</script>

<style scoped>
.collapse-icon{
  position: relative;
  padding-right: 8px;
  padding-left: 0px;
}

.padding-title {
  text-wrap: nowrap;
  padding: 4px 0px;
}

.padding-icon {
  padding-right: 20px;
}
</style>
